import axios, { AxiosError } from "axios";
import { useMutation } from "react-query";

const PublishSurveyApiService = async (request: number): Promise<boolean> => {
  const url = `/forms/${request}/publish/`;
  const { data } = await axios.post(url);
  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const usePublishSurveyApiService = () =>
  // eslint-disable-next-line
  useMutation<boolean, AxiosError, any>(
    PublishSurveyApiService, {
      mutationKey: ["PublishSurveyApiService"]
    }
  );
export default usePublishSurveyApiService;